const Inputs = {
  el: {
    checkboxes: document.querySelectorAll('.checkbox-hack'),
    inputGroupHasUnit: document.querySelectorAll('.input-group--has-unit'),
  },

  init: () => {
    if (Inputs.el.inputGroupHasUnit) {
      Array.prototype.forEach.call(Inputs.el.inputGroupHasUnit, (inputGroup) => {
        const unit = inputGroup.querySelector('.input-group__unit')
        const input = inputGroup.querySelector('input')
        const sizes = unit.getBoundingClientRect()
        const width = sizes['width']

        input.style.paddingRight = 30 + width + 'px'
      })
    }
  },
}

export default Inputs
